import Vue from 'vue'
import Router from 'vue-router'
// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
 title: 'title'               the name show in submenu and breadcrumb (recommend set)
 icon: 'svg-name'             the icon show in the sidebar,
 }
 **/

//所有权限通用路由表
//如首页和登录页和一些不用权限的公用页面
export const constantRouterMap = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true,
  },
  {
    path: '/error/401',
    component: () => import('@/views/error/401'),
    hidden: true,
  },
  {
    path: '/error/404',
    component: () => import('@/views/error/404'),
    hidden: true,
  },
  {
    path: '',
    component: Layout,
    name: 'Index',
    // hidden: true,
    children: [
      {
        path: '/',
        name: 'Dashboard',
        meta: { title: '首页', icon: 'dashboard', affix: true },
        component: () => import('@/views/dashboard/index'),
      },
    ],
  },
  {
    path: '',
    component: Layout,
    name: 'Info',
    hidden: true,
    children: [
      {
        path: '/info',
        component: () => import('@/views/info/index'),
      },
    ],
  },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index'),
      },
    ],
  },
]

//实例化vue的时候只挂载constantRouter
export default new Router({
  mode: 'history',
  routes: constantRouterMap,
})

//异步挂载的路由
//动态需要根据权限加载的路由表
//meta无permissions字段则不做权限控制
export const asyncRouterMap = [
  // {
  //     path: "",
  //     component: Layout,
  //     alwaysShow: true,
  //     name: "System",
  //     meta: {title: "系统管理", permissions: ["admin", "role"], icon: "system"},
  //     children: [
  //         {
  //             path: "/admin/list",
  //             name: "Admin",
  //             component: () => import("@/views/admin/index"),
  //             meta: {title: "管理员列表", permissions: ["admin"]}
  //         },
  //         {
  //             path: "/roles",
  //             name: "Role",
  //             component: () => import("@/views/role/index"),
  //             meta: {title: "角色列表", permissions: ["role"]}
  //         }
  //     ]
  // },
  // {
  //     path: "",
  //     component: Layout,
  //     alwaysShow: true,
  //     name: "AppClient",
  //     meta: {title: "客户端管理", permissions: ["admin", "appClientList"], icon: "users"},
  //     children: [
  //         {
  //             path: "/app-client/list",
  //             name: "AppClientList",
  //             component: () => import("@/views/appClient/index"),
  //             meta: {title: "客户端列表", permissions: ["admin", "appClientList"]}
  //         }
  //     ]
  // },
  // {
  //     path: "",
  //     component: Layout,
  //     alwaysShow: true,
  //     name: "ApiAccount",
  //     meta: {
  //         title: "供应商账户管理",
  //         icon: "system",
  //         permissions: ["admin", "apiAccountList", "apiAccountRequestLogs"]
  //     },
  //     children: [
  //         {
  //             path: "/api-account-list",
  //             name: "ApiAccountList",
  //             component: () => import("@/views/apiAccount/index"),
  //             meta: {title: "账户列表", permissions: ["admin", "apiAccountList"]}
  //         },
  //         {
  //             path: "/api-account-request-logs",
  //             name: "ApiAccountRequestLogs",
  //             component: () => import("@/views/apiAccount/requestLogs"),
  //             meta: {title: "账户请求日志", permissions: ["admin", "apiAccountRequestLogs"]}
  //         }
  //     ]
  // },
  {
    path: '',
    component: Layout,
    alwaysShow: true,
    name: 'Users',
    meta: { title: '用户管理', permissions: ['admin', 'users'], icon: 'users' },
    children: [
      {
        path: '/user/list',
        name: 'users',
        component: () => import('@/views/user/index'),
        meta: { title: '用户列表', permissions: ['admin', 'users'] },
      },
    ],
  },
  {
    path: '',
    component: Layout,
    alwaysShow: true,
    name: 'Hotels',
    meta: {
      title: '酒店管理',
      icon: 'jd',
      permissions: ['admin', 'hotelList'],
    },
    children: [
      {
        path: '/hotelList',
        name: 'HotelList',
        component: () => import('@/views/hotels/hotelList.vue'),
        meta: { title: '酒店列表', permissions: ['admin', 'hotelList'] },
      },
      {
        path: '/roomTypeList',
        name: 'RoomTypeList',
        component: () => import('@/views/hotels/roomTypeList.vue'),
        meta: { title: '房型列表', permissions: ['admin', 'roomTypeList'] },
      },
      {
        path: '/roomStatusList',
        name: 'RoomStatusList',
        component: () => import('@/views/hotels/roomStatusList.vue'),
        meta: { title: '房态列表', permissions: ['admin', 'roomStatusList'] },
      },
      {
        path: '/hotelImageList',
        name: 'HotelImageList',
        component: () => import('@/views/hotels/hotelImageList.vue'),
        meta: { title: '相册列表', permissions: ['admin', 'hotelImageList'] },
      },
      {
        path: '/hotelCommentList',
        name: 'HotelCommentList',
        component: () => import('@/views/orderComment/index.vue'),
        meta: { title: '评论列表', permissions: ['admin', 'hotelCommentList'] },
      },
    ],
  },
  // {
  //     path: "",
  //     component: Layout,
  //     alwaysShow: true,
  //     name: "JinJiangHotels",
  //     meta: { title: "供应商酒店管理", icon: "jd", permissions: ["admin","hotelList"] },
  //     children: [
  //         {
  //             path: "/jinJiang/hotelList",
  //             name: "JinJiangHotelList",
  //             component: () => import("@/views/jinJiangHotels/hotelList.vue"),
  //             meta: { title: "酒店列表", permissions: ["admin","jinJiangHotelList"] }
  //         },
  //         {
  //             path: "/jinJiang/roomTypeList",
  //             name: "JinJiangRoomTypeList",
  //             component: () => import("@/views/jinJiangHotels/roomTypeList.vue"),
  //             meta: { title: "房型列表", permissions: ["admin","jinJiangRoomTypeList"] }
  //         },
  //         {
  //             path: "/jinJiang/roomStatusList",
  //             name: "JinJiangRoomStatusList",
  //             component: () => import("@/views/jinJiangHotels/roomStatusList.vue"),
  //             meta: { title: "房态列表", permissions: ["admin","jinJiangRoomStatusList"] }
  //         },
  //         {
  //             path: "/jinJiang/hotelImageList",
  //             name: "JinJiangHotelImageList",
  //             component: () => import("@/views/jinJiangHotels/hotelImageList.vue"),
  //             meta: { title: "相册列表", permissions: ["admin","jinJiangHotelImageList"] }
  //         }
  //     ]
  // },
  // {
  //     path: "",
  //     component: Layout,
  //     alwaysShow: true,
  //     name: "Rooms",
  //     meta: { title: "房型管理", icon: "fx" , permissions: ["admin","subBasicRoomTypeList","salesRoomTypeList","pushRoomDataLogList"]},
  //     children: [
  //         // {
  //         //     path: "/subBasicRoomTypeList",
  //         //     name: "SubBasicRoomTypeList",
  //         //     component: () => import("@/views/rooms/subBasicRoomTypeList"),
  //         //     meta: { title: "子物理房型列表", permissions: ["admin","subBasicRoomTypeList"] }
  //         // },
  //         {
  //             path: "/salesRoomTypeList",
  //             name: "SalesRoomTypeList",
  //             component: () => import("@/views/rooms/salesRoomTypeList"),
  //             meta: { title: "售卖房型列表", permissions: ["admin","salesRoomTypeList"] }
  //         },
  //     ]
  // },
  {
    path: '',
    component: Layout,
    alwaysShow: true,
    name: 'Order',
    meta: {
      title: '订单管理',
      icon: 'dd',
      permissions: ['admin', 'orderList'],
    },
    children: [
      {
        path: '/orderList',
        name: 'OrderList',
        component: () => import('@/views/order/orderList'),
        meta: { title: '订单列表', permissions: ['admin', 'orderList'] },
      },
    ],
  },
  {
    path: '',
    component: Layout,
    alwaysShow: true,
    name: 'JinJiangOrder',
    meta: {
      title: '供应商订单管理',
      icon: 'dd',
      permissions: ['admin', 'jinJiangOrderList'],
    },
    children: [
      {
        path: '/jinJiang/orderList',
        name: 'JinJiangOrderList',
        component: () => import('@/views/jinJiangOrder/orderList'),
        meta: {
          title: '订单列表',
          permissions: ['admin', 'jinJiangOrderList'],
        },
      },
    ],
  },
  {
    path: '',
    component: Layout,
    alwaysShow: true,
    name: 'System',
    meta: {
      title: '建站管理',
      icon: 'content',
      permissions: ['admin', 'system'],
    },
    children: [
      {
        path: '/system/config',
        name: 'Config',
        component: () => import('@/views/system/config'),
        meta: { title: '参数设置', permissions: ['admin', 'system'] },
      },
      {
        path: '/system/feedback',
        name: 'Feedback',
        component: () => import('@/views/feedback/index.vue'),
        meta: { title: '意见反馈', permissions: ['admin', 'feedback'] },
      },
    ],
  },
  {
    path: '',
    component: Layout,
    alwaysShow: true,
    name: 'Rebate',
    meta: {
      title: '返利管理',
      icon: 'content',
      permissions: ['admin', 'rebate'],
    },
    children: [
      {
        path: '/orderRebate/index',
        name: 'OrderRebate',
        component: () => import('@/views/orderRebate/index'),
        meta: { title: '返利记录', permissions: ['admin', 'orderRebate'] },
      },
      {
        path: '/Withdrawal/index',
        name: 'Withdrawal',
        component: () => import('@/views/Withdrawal/index'),
        meta: { title: '提现记录', permissions: ['admin', 'withdrawal'] },
      },
    ],
  },
  // {
  //     path: "",
  //     component: Layout,
  //     alwaysShow: true,
  //     name: "User",
  //     meta: {title: "用户管理", permissions: ["admin", "user"], icon: "users"},
  //     children: [
  //         {
  //             path: "/user/list",
  //             name: "Users",
  //             component: () => import("@/views/user/index"),
  //             meta: {title: "用户列表", permissions: ["admin", "user"]}
  //         }
  //     ]
  // },
  //
  // {
  //     path: "",
  //     component: Layout,
  //     alwaysShow: true,
  //     name: "Content",
  //     meta: {
  //         title: "内容管理",
  //         permissions: ["banner", "about"],
  //         icon: "content"
  //     },
  //     children: [
  //         {
  //             path: "/banner/list",
  //             name: "Banners",
  //             component: () => import("@/views/banner/index"),
  //             meta: {title: "轮播图设置", permissions: ["banner"]}
  //         },
  //         {
  //             path: "/about",
  //             name: "About",
  //             component: () => import("@/views/about/index"),
  //             meta: {title: "关于我们", permissions: ["about"]}
  //         }
  //     ]
  // },

  // {
  //     path: "",
  //     component: Layout,
  //     alwaysShow: true,
  //     name: "Others",
  //     meta: {title: "其他", icon: "others"},
  //     children: [
  //         {
  //             path: "/map",
  //             name: "Map",
  //             component: () => import("@/views/others/map"),
  //             meta: {title: "地图"}
  //         }
  //     ]
  // },
  { path: '*', redirect: '/error/404', hidden: true },
]
